export const RADIO_LINKS = [
    'https://s5.myradiostream.com:42089',
    'http://s5.myradiostream.com:42088'
];